import { useMemo } from 'react';
import { useCart } from '../../../hooks/useCart';
import { useGiftExperienceFeatureFlag } from '../../../hooks/useGiftExperienceFeatureFlag';

export const useCheckoutGiftSectionError = () => {
  const enabled = useGiftExperienceFeatureFlag();
  const {
    cart: {
      attributes: { isGiftOrder, isGiftingAllowed }
    }
  } = useCart();

  const error = useMemo(() => {
    if (isGiftOrder && !isGiftingAllowed) {
      return 'Due to updates to your order, it is no longer eligible for gifting options.';
    }

    if (isGiftOrder && !enabled) {
      return 'Gifting options are not available at this time.';
    }
  }, [enabled, isGiftOrder, isGiftingAllowed]);

  return error;
};
